export class listOptions {
    signatory: boolean;
    vehicleDetails: boolean;
    checklist: boolean;
    picturesPreSelected: boolean;
    showCost: boolean;
    showSeverity: boolean;
    croppImages: boolean;
    constructor() { }
}

export class Report {

    prefix: string;
    image: any;
    selectorCost: string;
    selectorReport: string;
    selectorButton: string;
    selectorSvg: string;
    selectorSvgColor: string;
    selectorSens: string;
    state: listOptions;
    simple: listOptions;
    oldDamages: boolean
    checkDamages: boolean
    constructor() { }
}

export class ApiWebHookOptions {

    newTchek: boolean;
    detectionFinished: boolean;
    detectionFinishedCloud: boolean;
    sendToSI: boolean;
    multiplePictureDamage: boolean
    croppedImages: boolean;
    webhookPdf: boolean;
    webhookPdfCloud: boolean;
    constructor() { }
}

export class ApiWebHook {

    headerKey: string;
    publicKey: string;
    privateKey: string;
    webhook: string;
    options: ApiWebHookOptions;
    constructor() { }
}

export class Style {

    newDamageColor: string;
    damageColor: string;
    gamma: number
    contrast: number
    saturation: number
    dashboard: { display: string, value: string }[];
    constructor() { }
}

export class Cost {
    class: string;
    location: {
        value: string
        remplacementCost: number;
        price: {
            typeDamage: string,
            value: { severity: string, cost: number }[]
        }[];
    }[]
    constructor() { }
}

export class VehicleSettings {
    orNumber: boolean;
    vinNumber: boolean;
    checklist: CheckListVehicle[];
    classes: { value: string, display: string }[];
    constructor() { }
}

export class Accessibility {
    showIcons: boolean;
    showImmatPicture: boolean;
    useFastTrack: boolean;
    fastTrackComp: boolean;
    fastTrackZoom: boolean;
    fastTrackL1: boolean;
    fastTrackL2: boolean;
    fastTrackL3: boolean;
    deleteDamageDuringFTAskReason?: boolean;
    endOfFastTrackSimplified?: boolean;

    constructor() { }
}

export class Company {
    name: string;
    address: string;
    phone: string;
    mail: string;
    site: string;
    other: string;
    footer: string;
    constructor() { }
}

export class Settings {

    user: string;
    report: Report;
    option: Object;
    language: string;
    notification: Object;
    users: Object;
    api: ApiWebHook;
    style: Style;
    vehicle: VehicleSettings;
    accessibility: Accessibility;
    cost: Cost[];
    company: Company;
    companyLogo: Parse.File;
    companyStamp: Parse.File;
    filterDamage: { type: string, proba: number, number: number }[];
    footer: string;
    constructor() { }
}

export interface CheckListVehicle {
    reportType: string[];
    id: string;
    display: string;
    value: boolean;
    classIds: string[];
}


// WEBPACK FOOTER //
// ./src/app/model/settings.model.ts